// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-bar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgb(242, 242, 242);
  border-right-color: rgb(200, 200, 200);
  border-right-style: solid;
  border-right-width: 0.8px;
}

.side-bar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 96px;
  width: 100%;
}

.side-bar-header.searching {
  height: 56px;
}

.side-bar-tabs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
}

.side-bar-no-conversations {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: min(90px, 30%);
  gap: 10px;
  width: 90%;
}

.side-bar-no-conversations-icon {
  padding-bottom: 10px;
}

.side-bar-no-conversations-header {
  color: black;
  font-family: Roboto, sans-serif;
  font-size: 22px;
  font-weight: 400;
  text-align: center;
}

.side-bar-no-conversations-text {
  color: rgba(142, 142, 147, 1);
  font-family: Roboto, sans-serif;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
}

.side-bar-start-chat-button {
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 36px;
  gap: 8px;
  background: #DE4858;
  border: none;
  box-shadow: 0px 10px 10px -3px color-mix(in srgb, var(--netsfere-red) 20%, transparent);
  border-radius: 1.67772e+07px;
  cursor: pointer;
  margin-top: 10px;
}

.conversation-list-container {
  height: calc(100% - 96px);
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.conversation-list-container.searching {
  height: calc(100% - 56px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uFAAuF;EACvF,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".side-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  background-color: rgb(242, 242, 242);\n  border-right-color: rgb(200, 200, 200);\n  border-right-style: solid;\n  border-right-width: 0.8px;\n}\n\n.side-bar-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 96px;\n  width: 100%;\n}\n\n.side-bar-header.searching {\n  height: 56px;\n}\n\n.side-bar-tabs {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 100%;\n}\n\n.side-bar-no-conversations {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: min(90px, 30%);\n  gap: 10px;\n  width: 90%;\n}\n\n.side-bar-no-conversations-icon {\n  padding-bottom: 10px;\n}\n\n.side-bar-no-conversations-header {\n  color: black;\n  font-family: Roboto, sans-serif;\n  font-size: 22px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.side-bar-no-conversations-text {\n  color: rgba(142, 142, 147, 1);\n  font-family: Roboto, sans-serif;\n  font-size: 17px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.side-bar-start-chat-button {\n  color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 36px;\n  gap: 8px;\n  background: #DE4858;\n  border: none;\n  box-shadow: 0px 10px 10px -3px color-mix(in srgb, var(--netsfere-red) 20%, transparent);\n  border-radius: 1.67772e+07px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.conversation-list-container {\n  height: calc(100% - 96px);\n  width: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.conversation-list-container.searching {\n  height: calc(100% - 56px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
